import { createContext, useContext, useState, type ReactNode } from 'react'
import type { TimeRange } from '@/components/data-truth/TimeRangePicker'

export type Env = 'prod' | 'staging' | 'dev'

interface ShellState {
  env: Env
  setEnv: (env: Env) => void
  range: TimeRange
  setRange: (range: TimeRange) => void
  navOpen: boolean
  setNavOpen: (open: boolean) => void
}

const ShellContext = createContext<ShellState | null>(null)

export function ShellProvider({ children }: { children: ReactNode }) {
  const [env, setEnv] = useState<Env>('prod')
  const [range, setRange] = useState<TimeRange>('1h')
  const [navOpen, setNavOpen] = useState(true)
  return (
    <ShellContext.Provider value={{ env, setEnv, range, setRange, navOpen, setNavOpen }}>
      {children}
    </ShellContext.Provider>
  )
}

export function useShell() {
  const ctx = useContext(ShellContext)
  if (!ctx) throw new Error('useShell must be used within ShellProvider')
  return ctx
}
